export const createRequestLoginHandler =
  (requestLogin) =>
  (...args) => {
    requestLogin(...args);
  };
